import { ReactNode, createContext } from "react";

import { usePreloadedQuery } from "react-relay";
import { MY_DETAILS_QUERY_PAUTH } from "./PatientAuthQuery";
import {
  PatientAuthQueryQuery,
  PatientAuthQueryQuery$data,
} from "./__generated__/PatientAuthQueryQuery.graphql";

// Types for the context value
interface PatientAuthType {
  refresh: () => void;
  isSignedIn: boolean;
  patient?: PatientAuthQueryQuery$data["myPatientDetails"];
}

// Create a context with the initial value and type assertion
export const PatientAuth = createContext<PatientAuthType | null>(null);

interface PatientAuthProviderProps {
  children: ReactNode;
  queryRef: any;
  refresh: () => void;
}

// Provider component
export const PatientAuthProvider = ({
  children,
  refresh,
  queryRef,
}: PatientAuthProviderProps) => {
  const data = usePreloadedQuery<PatientAuthQueryQuery>(
    MY_DETAILS_QUERY_PAUTH,
    queryRef
  );

  const patient = data.myPatientDetails;

  const isSignedIn = !!patient;

  return (
    <PatientAuth.Provider value={{ isSignedIn, patient, refresh }}>
      {/* Ideally the notifications provider should be at the top level, and work for admin and patient */}
      {/* Right now patient requires the Patient Auth provider as the users are different */}
      {/* For patients we are forced to put it here for now */}
      {/* In the future there should be only one Notifications provider for all */}
      {children}
    </PatientAuth.Provider>
  );
};

interface AnonymousPatientAuthProviderProps {
  children: ReactNode;
  refresh: () => void;
}

// Fallback provider used when the patient auth query fails (e.g. network error)
// so anonymous users can still progress through the quote flow.
export const AnonymousPatientAuthProvider = ({
  children,
  refresh,
}: AnonymousPatientAuthProviderProps) => {
  return (
    <PatientAuth.Provider
      value={{ isSignedIn: false, patient: null, refresh }}
    >
      {children}
    </PatientAuth.Provider>
  );
};
